import {
  TrackerAddMealConnectorApollo,
  SaveAsUserMealConnectorApollo,
  useAppContext,
} from '@front-activerse/common-components';
import TrackerAddMealContainer from './TrackerAddDescribeMealContainer';
import { useParams, useLocation } from 'react-router-dom';
import type { UnifiedMealData } from '../types';

interface LocationState {
  mealData: UnifiedMealData;
  requestId?: string;
  timestamp?: number;
}

const TrackerAddDescribeMealPage: React.FC<{ fromUserMeals?: boolean }> = ({ fromUserMeals }) => {
  const { post } = useAppContext();
  const location = useLocation();
  const state = location.state as LocationState | null;
  const { dietMealId } = useParams<{ dietMealId: string }>();

  const mealData = state?.mealData ?? null;

  if (!mealData || !dietMealId) return null;

  return (
    <TrackerAddMealConnectorApollo post={post}>
      {({ addMeal }: { addMeal: (input: any, saveYourMeal: boolean) => Promise<any> }) => (
        <SaveAsUserMealConnectorApollo post={post}>
          {({ saveAsUserMeal }: { saveAsUserMeal: (input: any) => Promise<any> }) => (
            <TrackerAddMealContainer
              mealData={mealData}
              addMeal={addMeal}
              saveAsUserMeal={saveAsUserMeal}
              key={dietMealId}
              dietMealId={dietMealId}
              requestId={state?.requestId}
              fromUserMeals={fromUserMeals}
            />
          )}
        </SaveAsUserMealConnectorApollo>
      )}
    </TrackerAddMealConnectorApollo>
  );
};

export default TrackerAddDescribeMealPage;
